<template>
  <div class='dashboard-editor-container content-view'>
    <div class="panel-msg">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-select v-model="value" placeholder="请选择" @change="changeSite">
            <el-option v-for="item in siteList" :key="item.siteId" :label="item.siteName" :value="item.siteId">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="19">
          <div class="equipment-box fr">
            <EquipmentNumbers :cameraCount="cameraCount" :siteCount="siteCount" :collectDeviceCount="collectDeviceCount"
              :controlDeviceCount="controlDeviceCount" :userCount="userCount" />
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="site-container">
      <el-row :gutter="20">
        <el-col :span="17">
          <div class="col-bg mb15">
            <div class="col-bg-horn"></div>
            <div class="tabs-list">
              <card-list ref="card" :realDevList="realDevList"
                @chageCard="chageCard">
              </card-list>
            </div>
          </div>
          <div class="col-bg">
            <div class="col-bg-horn"></div>
            <div>
              <div class="btn-box">
                <el-radio-group class="change-radio" v-model="radio1" @change="changeRadio">
                  <el-radio-button label="24" :disabled="disabled">近24小时</el-radio-button>
                  <el-radio-button label="3" :disabled="disabled">近3天</el-radio-button>
                  <el-radio-button label="7" :disabled="disabled">近7天</el-radio-button>
                </el-radio-group>
              </div>
              <p class="chart-title">{{chartParam.aliasName}}统计</p>
              <div class="chart">
                <TotalChart :xdata="xdata" :warnList="warnList" :chartParam="chartParam" :dataList="dataList" />
                <!-- <div id="chart"></div> -->
                <!-- <div v-show="xData.length>0" id="chart"></div> -->
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="col-bg">
            <div class="col-bg-horn"></div>
            <el-radio-group class="change-radio" v-model="radio2" @change="changeRadio2">
              <el-radio-button label="24" :disabled="disabled">近24小时</el-radio-button>
              <el-radio-button label="3" :disabled="disabled">近3天</el-radio-button>
              <el-radio-button label="7" :disabled="disabled">近7天</el-radio-button>
            </el-radio-group>

            <div style="margin-bottom:20px;">
              <RingChart :chart-data="topThreeAlarm" />
            </div>

            <line-chart :chart-data="topFiveAlarm" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { listSite } from "@/api/configuration/site";
import { siteDate, timeChart } from "@/api/analysis/time";
import { getAlarmChartStatistics } from "@/api/dash/device";
import cardList from "./compontents/cardList";
import LineChart from "./compontents/LineChart";
import RingChart from "./compontents/RingChart";
import TotalChart from "./compontents/TotalChart";
import EquipmentNumbers from "./compontents/EquipmentNumbers";
export default {
  name: "",
  data() {
    return {
      disabled: false,
      dataList: [],
      xdata: [],
      value: "",
      siteId: "",
      radio1: "24",
      radio2: "24",
      totalData: {},
      realDevList: [],
      warnList: [],
      topFiveAlarm: {},
      topThreeAlarm: {},
      cameraCount: 0,
      siteCount: 0,
      collectDeviceCount: 0,
      controlDeviceCount: 0,
      userCount: 0,
      chartParam: {
        time: "12",
        unit: "h",
        devId: "",
        aliasName: "",
        portNumber: ""
      },
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        enterpriseId: undefined,
        siteName: undefined,
        leader: undefined,
        phone: undefined,
        scale: undefined,
        address: undefined,
        status: undefined,
        description: undefined,
        plan: undefined,
        warning: undefined,
        imageUrl: undefined,
        enableTime: undefined
      },
      siteList: [],
      query: null
    };
  },
  components: {
    EquipmentNumbers,
    cardList,
    RingChart,
    LineChart,
    TotalChart
  },
  created() {
    // if(this.$route.query){
    // 	this.init()
    // }else{
    // 	this.siteList = this.$store.getters.siteList;
    // 	this.$set(this.chartParam, "siteId", this.siteList[0].siteId);
    // 	this.value = this.siteList[0].siteName;
    // 	this.getSiteDate(this.siteList[0].siteId);
    // }
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
			
      this.getAlarmChartStatistics(24, this.siteId);
    });
  },
  methods: {
    init() {
			this.siteList = this.$store.getters.siteList;
      if (this.$route.query.siteId) {
        this.siteId = this.$route.query.siteId;
        this.$set(this.chartParam, "siteId", this.siteId);
        this.value = this.selectDictLabel(this.siteList, this.siteId);
        this.getSiteDate(this.siteId);
      } else {
        this.siteId = this.siteList[0].siteId;
        this.$set(this.chartParam, "siteId", this.siteId);
				this.value = this.siteList[0].siteName;
        this.getSiteDate(this.siteId);
      }
    },
    //站点回显
    selectDictLabel(datas, value) {
      var actions = [];
      Object.keys(datas).map(key => {
        if (datas[key].siteId == "" + value) {
          actions.push(datas[key].siteName);
          return false;
        }
      });
      return actions.join("");
    },
    /** 查询【请填写功能名称】列表 */
    getList() {
      this.$set(this.queryParams, "roles", this.$store.getters.roles[0]);
      listSite(this.queryParams).then(response => {
        this.value = response.rows[0].siteName;
        this.siteList = response.rows;
        this.getSiteDate(response.rows[0].siteId);
      });
    },
    //获取实时数据列表数据
    getSiteDate(id) {
      let param = {
        siteId: id
      };
      siteDate(param).then(response => {
        this.realDevList = response.data.realDevList || [];
        this.abnormalCount = response.data.abnormalCount;
        this.siteCount = response.data.siteCount || 0;
        this.collectDeviceCount = response.data.collectDeviceCount || 0;
        this.controlDeviceCount = response.data.controlDeviceCount || 0;
        this.userCount = response.data.userCount || 0;
        if (this.realDevList.length <= 0) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
        this.getTimeChart();
      });
    },
    getTimeChart() {
      this.$set(this.chartParam, "time", "24");
      this.$set(this.chartParam, "unit", "h");
      // this.$set(this.chartParam, "devId", this.realDevList[0].devId);
      // this.$set(this.chartParam, "portNumber", this.realDevList[0].portNumber);
      // this.$set(this.chartParam, "aliasName", this.realDevList[0].attrName);
			let query = this.$route.query;
      if (query) {
        this.realDevList.forEach((val, i) => {
          if (val.attrId == query.attrId && val.devId == query.devId) {
            this.$set(this.chartParam, "devId", this.realDevList[i].devId);
            this.$set( this.chartParam, "portNumber", this.realDevList[i].portNumber);
						this.$set( this.chartParam, "aliasName", this.realDevList[i].attrName);
						this.$refs.card.xindex=i
						if(i>=5){
							i=-i+4
							this.$refs.card.currentOffset = i*245
						}
          }else{
						this.$set(this.chartParam, "devId", this.realDevList[0].devId);
      			this.$set(this.chartParam, "portNumber", this.realDevList[0].portNumber);
      			this.$set(this.chartParam, "aliasName", this.realDevList[0].attrName);
					}
        });
      }
      timeChart(this.chartParam).then(response => {
        this.dataList = response.data.dataList || [];
        this.xdata = response.data.timeList || [];
        this.warnList = response.data.warnList;
      });
    },
    getAlarmChartStatistics(time, siteId) {
      let data = {
        time: time,
        unit: time == 24 ? "h" : "d",
        siteId: siteId
      };
      getAlarmChartStatistics(data).then(res => {
        if (res.data) {
          this.topFiveAlarm = res.data.topFiveAlarm;
          this.topThreeAlarm = res.data.topThreeAlarm;
        }
      });
    },
    changeSite(value) {
      this.siteId = value;
      this.$set(this.chartParam, "siteId", value);
      this.radio2 = "24";
      this.radio1 = "24";
      this.getSiteDate(value);
      this.getAlarmChartStatistics(24, value);
			this.$refs.card.currentOffset = 0;
			this.$refs.card.xindex = 0
    },
    chageCard(item) {
      this.$set(this.chartParam, "devId", item.devId);
      this.$set(this.chartParam, "aliasName", item.attrName);
      this.$set(this.chartParam, "portNumber", item.portNumber);
      this.radio1 = "24";
      this.changeChart("24");
    },
    changeRadio(value) {
      this.changeChart(value);
    },
    changeRadio2(value) {
      this.getAlarmChartStatistics(value, this.siteList[0].siteId);
    },
    changeChart(time) {
      if (time == 24) {
        this.$set(this.chartParam, "unit", "h");
      } else {
        this.$set(this.chartParam, "unit", "d");
      }
      this.$set(this.chartParam, "time", time);
      timeChart(this.chartParam).then(response => {
        this.dataList = response.data.dataList;
        this.xdata = response.data.timeList;
        this.warnList = response.data.warnList;
      });
    }
  },
  watch: {
    realDevList: {
      handler: function(newValue, oldValue) {
        if (newValue.length > 0) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      },
      deep: true
    }
  },
  updated() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  }
};
</script>
<style lang='scss' scoped>
.site-container {
  margin-top: 30px;
  .col-bg {
    // padding: 20px 0 30px 0;
    padding: 25px 0;
    background-color: rgba(7, 31, 82, 0.2);
  }
}
.equipment-box {
  width: 900px;
}
.tabs-list {
  padding: 0 50px;
  position: relative;
}
.btn-box {
  text-align: left;
  margin-left: 30px;
}
.chart {
  // padding: 20px;
  min-height: 340px;
  .fr {
    font-size: 14px;
  }
  #chart {
    height: 340px;
    width: 100%;
  }
}
.chart-title {
  color: #fff;
  font-size: 16px;
  margin-left: 20px;
  margin-top: 0;
  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 16px;
    background-color: #14cfba;
    border-radius: 10px;
    vertical-align: text-bottom;
    margin-right: 15px;
  }
}
// .dashboard-editor-container{
// 	height: 100%;
// 	width: 100%;

// }
</style>
